import React from "react";

/**
 * Schema.org ItemList JSON-LD pour les mini-threads.
 * Signale à Google qu'une liste éditoriale/curée de villes existe sur la page.
 * Peut déclencher des Rich Results "Liste" dans les SERP.
 *
 * Props :
 *   - name        : titre humain du thread ("Voyance en bord de mer")
 *   - description : phrase de contexte SEO
 *   - hubUrl      : URL de la page où le thread est visible (hub)
 *   - cities      : tableau { slug, name, code, [justification] }
 *   - urlBuilder  : function(city) → URL complète canonique de la ville (optionnel,
 *                   par défaut https://jaimelavoyance.fr/voyance-{slug}-{code})
 */
const ThreadJsonLd = ({ name, description, hubUrl, cities, urlBuilder }) => {
  const build = urlBuilder
    || ((c) => `https://jaimelavoyance.fr/voyance-${c.slug}-${c.code.toLowerCase()}`);
  // Retire toute ancre "#thread-xxx" du hubUrl :
  // Google Rich Results refuse les URLs à ancre dans les carrousels ItemList
  // car une ancre pointe vers la même page (pas une page distincte).
  const cleanHubUrl = (hubUrl || "").split("#")[0];
  const payload = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name,
    description,
    url: cleanHubUrl,
    numberOfItems: cities.length,
    itemListElement: cities.map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      url: build(c),
      name: `${c.name} (${c.code})`,
      ...(c.justification ? { description: c.justification } : {}),
    })),
  };
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(payload) }}
    />
  );
};

export default ThreadJsonLd;
